var PiedraPapelTijera = /** @class */ (function () {
    /**
     * Creates an instance of PiedraPapelTijera.
     * @param {Configuration} config
     */
    function PiedraPapelTijera(config) {
        var _a;
        this._loss = 0;
        this._success = 0;
        this._tie = 0;
        this._counter = 0;
        this._ended = false;
        this._intents = (_a = config["intents"]) !== null && _a !== void 0 ? _a : 3;
        this._finished = config.finished;
        this._result = config.result;
    }
    /**
     * Obtener el codigo de piedra
     *
     * @return {*}  {number}
     */
    PiedraPapelTijera.prototype.getPiedra = function () {
        return 0;
    };
    /**
     * Obtener el codigo de tijera
     *
     * @return {*}  {number}
     */
    PiedraPapelTijera.prototype.getPapel = function () {
        return 1;
    };
    /**
     * Obtener el codigo de tijera
     *
     * @return {*}  {number}
     */
    PiedraPapelTijera.prototype.getTijera = function () {
        return 2;
    };
    /**
     * Obtener la aserción de Homero
     *
     * @param {number} code
     * @return {*}
     */
    PiedraPapelTijera.prototype.getHomero = function (code) {
        if (code == 0) {
            return "piedra";
        }
        else if (code == 1) {
            return "papel";
        }
        else if (code == 2) {
            return "tijera";
        }
    };
    /**
     * Adivinar el numero
     *
     * @param {number} assert
     */
    PiedraPapelTijera.prototype.play = function (assert) {
        // Añadir en uno el contador de intentos
        this._counter += 1;
        if (!this._ended) {
            // Obtener lo que homero a seleccionado
            var homero = this.random();
            // Validar la asercion con el de homero
            var validate = this.validate(assert, homero);
            // Retornar el resultado
            this._result({
                homero: homero,
                validate: validate,
            });
            // Finalizar si a alcanzado el numero máximo de intentos
            if (this._counter == this._intents) {
                this.stop();
            }
        }
        else {
            this.stop();
        }
    };
    /**
     * Reiniciar el juego
     *
     */
    PiedraPapelTijera.prototype.restart = function () {
        this._loss = 0;
        this._success = 0;
        this._tie = 0;
        this._counter = 0;
        this._ended = false;
    };
    /**
     * Parar el juego
     *
     * @private
     */
    PiedraPapelTijera.prototype.stop = function () {
        this._ended = true;
        // Accionar el callback de finalizacion del juego
        this._finished({
            loss: this._loss,
            success: this._success,
            tie: this._tie,
        });
    };
    /**
     * Obtener un numero aleatorio del 0 al 2
     *
     * @private
     * @return {*}  {number}
     */
    PiedraPapelTijera.prototype.random = function () {
        return Math.floor(Math.random() * 3);
    };
    /**
     * Validar la asercion con el de Homero
     *
     * @private
     * @param {number} assert
     * @param {number} homero
     */
    PiedraPapelTijera.prototype.validate = function (assert, homero) {
        // piedra:0 > tijera
        // papel:1 > piedra
        // tijera:2 > papel
        // piedra = 0
        // papel = 1
        // tijera = 2
        var validate = [
            [0, 2],
            [1, 0],
            [2, 1], // tijera > piedra
        ];
        if (validate[assert][0] === homero) {
            // Empate
            this._loss += 1;
            return 2;
        }
        else if (validate[assert][1] === homero) {
            // Gana
            this._success += 1;
            return 1;
        }
        else {
            // Pierde
            this._loss += 1;
            return 0;
        }
    };
    return PiedraPapelTijera;
}());
export default PiedraPapelTijera;
